<div class="side-nav-bar">
    <acl-ngx-form-nav [items]="tabs" [activeItem]="activeTabName"></acl-ngx-form-nav>
</div>